<template>
  <label class="uk-margin" v-bind:for="name">
    <div class="uk-form-label uk-display-block" v-bind:for="name" v-html="label">
    </div>

    <div class="kmc-field-help-text" v-if="helpText" v-html="helpText">
    </div>

    <label class="kmc-input kmc-input-number">
      <span class="prefix">£</span>
      <input
          ref="input"
          :name="name"
          :id="name"
          :type="'text'"
          inputmode="numeric"
          @input="handleChange1"
          @blur="handleBlur"
      />
      <div class="border"></div>
      <span class="suffix"></span>
    </label>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </label>

</template>

<script>

import {ref, watch} from 'vue'
import {useField} from "vee-validate";
import {formatCurrency} from "../util";

export default {
  name: "KmcInputCurrency",
  components: {},
  props: {
    helpText: {
      type: String,
    },
    value: {
      type: String
    },
    name: {
      type: String,
      default: "field name"
    },
    label: {
      type: String,
      default: "missing label"
    },
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {});

    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })

    let handleChange1 = () => {
      input.value.value = formatCurrency(input.value.value)
      handleChange(input.value.value.replaceAll(',', ''));
    }

    return {
      input,
      handleChange1,
      handleBlur,
      errorMessage,
      meta,
    };
  }
}

</script>

